import React, { useEffect, useRef, useState, useContext } from "react";
import { Container, Row, Button } from "reactstrap";
import { NavLink, Link, useNavigate } from "react-router-dom";
import "./header.css";
import Logo from "../../assets/images/logo2.png";
import { AuthContext } from "../../context/AuthContext";

const nav_links = [
  {
    path: "/home",
    display: "Home",
  },
  {
    path: "/about",
    display: "About",
  },
  {
    path: "/corporate-tours",
    display: "Corporate Tours",
  },
  {
    display: "Group Tours",
    subLinks: [
      { path: "/GroupTourIndia", display: "Domestic" },
      { path: "/GroupTourInternational", display: "International" },
    ],
  },
  {
    display: "Tailor-made Packages",
    subLinks: [
      { path: "/tailor-made/india", display: "India" },
      { path: "/tailor-made/international", display: "International" },
    ],
  },
  {
    display: "Know More",
    subLinks: [
      { path: "/TermsAndConditions", display: "Terms and Conditions" },
      { path: "/visa", display: "Visa" },
    ],
  },
];

const Header = () => {
  const headerRef = useRef(null);
  const menuRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const navigate = useNavigate();
  const { user, dispatch } = useContext(AuthContext);

  const logout = () => {
    dispatch({ type: "LOGOUT" });
    navigate("/");
  };

  const stickyHeaderFunc = () => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (
          document.body.scrollTop > 80 ||
          document.documentElement.scrollTop > 80
        ) {
          headerRef.current.classList.add("sticky_header");
        } else {
          headerRef.current.classList.remove("sticky_header");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  };

  useEffect(() => {
    const cleanupScrollListener = stickyHeaderFunc();

    return cleanupScrollListener;
  }, []);

  const toggleMenu = () => {
    if (menuRef.current) {
      menuRef.current.classList.toggle("show_menu");
    }
  };

  const handleMouseEnter = (index) => {
    setDropdownOpen(index);
  };

  const handleMouseLeave = () => {
    setDropdownOpen(null);
  };

  return (
    <header className="header" ref={headerRef}>
      <Container fluid>
        <Row>
          <div className="nav_wrapper d-flex align-items-center justify-content-between">
            <div className="logo">
              <img src={Logo} alt="Parth Vacations" />
            </div>

            <div className="navigation" ref={menuRef}>
              <ul className="menu d-flex align-items-center gap-5">
                {nav_links.map((item, index) => (
                  <li
                    className="nav_item"
                    key={index}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                  >
                    {item.subLinks ? (
                      <div className="dropdown">
                        <span className="dropdown_toggle">{item.display}</span>
                        <ul className={`sub_menu ${dropdownOpen === index ? "show" : ""}`}>
                          {item.subLinks.map((subItem, subIndex) => (
                            <li key={subIndex}>
                              <NavLink to={subItem.path}>
                                {subItem.display}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <NavLink
                        to={item.path}
                        className={(navClass) =>
                          navClass.isActive ? "active_link" : ""
                        }
                      >
                        {item.display}
                      </NavLink>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="nav_right d-flex align-items-center gap-4">
              {user ? (
                <>
                  <h5 className="mb-0">{user.username}</h5>
                  <Button className="btn btn-dark" onClick={logout}>
                    Logout
                  </Button>
                </>
              ) : (
                <>
                  <Button className="btn secondary_btn">
                    <Link to="/login">Login</Link>
                  </Button>
                  <Button className="btn primary_btn">
                    <Link to="/register">Register</Link>
                  </Button>
                </>
              )}
            </div>

            <span className="mobile_menu" onClick={toggleMenu}>
              <i className="ri-menu-line"></i>
            </span>
          </div>
        </Row>
      </Container>
    </header>
  );
};

export default Header;
